import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { InputWidthValues } from '../../../../ui/gzInput';
// todo move subtitle for deployer when we do it fix reconfig agent too !!!
export const templateInstallAgentPanel = document.createElement('template');

templateInstallAgentPanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>
    <div class='content-wrapper'>
      <div class='form-wrapper'>
        <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='options-form-subtitle'></gz-title>
        <gz-reconfigure-agent-scheduler-form></gz-reconfigure-agent-scheduler-form>
        <gz-form-field id='automatically-reboot-checkbox' class='pt-2'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        </gz-form-field>
        <gz-info-box id='automatically-reboot-info' class='info-box-style mt-2' severity='warning'></gz-info-box>

        <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='credentials-manager-form-subtitle'></gz-title>
        <gz-credentials-manager-grid></gz-credentials-manager-grid>

        <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='install-deployer-form-subtitle'></gz-title>
        <gz-package-deployer-form context='edit'></gz-package-deployer-form>

        <gz-install-agent-additional-targets></gz-install-agent-additional-targets>

        <div class='d-flex'>
          <gz-form-field id='package-form-field' class='label-mw-250' label=''>
            <gz-dropdown gz-form-input localFiltering combobox type='dropdown'></gz-dropdown>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-button type='outline' class='ml-2' id='customize-package-button' disabled></gz-button>
        </div>
        <gz-info-box id='customize-package-info' class='box-info mt-2 hidden' severity='error'></gz-info-box>

        <div id='package-wrapper' class='hidden'>
          <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='general-details-subtitle'></gz-title>
          <gz-form-field id='language-form-field' class='label-mw-250' label=''>
            <gz-dropdown gz-form-input localFiltering combobox type='dropdown'></gz-dropdown>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-package-modules-form class='pt-1'></gz-package-modules-form>

          <gz-package-scan-modes-form></gz-package-scan-modes-form>

          <gz-package-security-server-assignment-grid context='edit'></gz-package-security-server-assignment-grid>

          <gz-package-miscellaneous-form context='edit'></gz-package-miscellaneous-form>

          <gz-package-settings-form context='edit'></gz-package-settings-form>

          <gz-package-use-proxy-form context='edit'></gz-package-use-proxy-form>

          <div class='d-flex pt-2'>
            <gz-form-field id='save-as-package-checkbox'>
                <gz-checkbox gz-form-input></gz-checkbox>
            </gz-form-field>
            <gz-form-field id='save-as-package-form-field' disabled>
              <gz-input gz-form-input inputWidth='${InputWidthValues.LARGE}'></gz-input>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </div>

          <gz-info-box id='remove-competitor-info' class='info-box-style' severity='warning'></gz-info-box>
        </div>
      </div>
      <div class='bottom-buttons'>
        <gz-button id='save-button'></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
